<template>
  <div class="animated fadeIn">
    <CRow>
      <el-form ref="queryForm" :model="queryForm" label-width="100px" :inline="true">
        <el-form-item label="關鍵字">
          <el-input v-model="queryForm.qstr" placeholder="編號,班名,序號,名稱,備註" ></el-input>
        </el-form-item>
        <el-form-item label="所屬單位">
            <el-select v-model="queryForm.organization" filterable placeholder="請選擇" clearable="" @change="onQueryOrganizationChange">
              <el-option
                v-for="item in organizations"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="群組">
            <el-select v-model="queryForm.groups" clearable multiple filterable placeholder="請選擇">
              <el-option
                v-for="group in queryGroups"
                :key="group.id"
                :label="group.name"
                :value="group.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="currentPage=1;query(pageSize,0,sort, order, queryForm)">查詢</el-button>
         <el-button type="primary" @click="download(sort,order, queryForm)">匯出</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="addDevice" v-if="$store.state.auth.role === 'admin' | $store.state.auth.role === 'org-admin'">新增</el-button>
          <el-button type="primary" @click="batchEdit" v-if="$store.state.auth.role === 'admin' | $store.state.auth.role === 'org-admin'">批次編輯</el-button>
          <el-button type="danger" @click="batchDelete" v-if="$store.state.auth.role === 'admin' | $store.state.auth.role === 'org-admin'">批次刪除</el-button>
        </el-form-item>
      </el-form>

    </CRow>
    <CRow>
    <el-table
             @sort-change = "sortChange"
            :data="accounts"
            style="width:100%"
            border
            stripe
            empty-text="暫無數據"
            :default-sort = "{prop: 'no', order: 'ascending'}"
            @selection-change="handleSelectionChange"
            :cell-class-name="tableCellClassName"
          >

           <el-table-column
              type="index"
              :index="indexFormatter"
              fixed
              >
            </el-table-column>
            <el-table-column
                label="人員編號"
                prop="no"
                sortable = "custom"
                width="120px"
            >
            </el-table-column>
            <el-table-column
                label="班級名稱"
                prop="class_name"
                sortable = "custom"
                width="120px"
            >
            </el-table-column>
          <el-table-column
          fixed
            type="selection"
            width="45">
          </el-table-column>
            <el-table-column
                label="月光機序號"
                prop="moonlight2_serial_number"
                sortable = "custom"
            >
            </el-table-column>
               <el-table-column
                label="所屬單位"
                prop="organization.name"
            >
            </el-table-column>
            <el-table-column
                label="名稱"
                prop="name"
                sortable = "custom"
            >
            </el-table-column>

              <el-table-column
                label="群組"
            >
             <template slot-scope="scope">
             
                   <span class="tag_group">
                     <el-tag effect="dark" v-for="group in scope.row.groups" :key="group.id" :type="group.type">{{group.name}}</el-tag>
                 </span>
                 
             </template>
            </el-table-column>
            <!--
            <el-table-column
                label="生效日期"
                prop="start_date"
                sortable = "custom"
                :formatter="dateFormatter"
                width="150px"
            >
            </el-table-column>
            -->
            <el-table-column
                label="失效日期"
                prop="end_date"
                sortable = "custom"
                :formatter="dateFormatter"
                width="130px"
            >
            </el-table-column>
            <el-table-column
                label="最新同步日期"
                prop="last_sync_date"
                sortable = "custom"
                :formatter="dateFormatter2"
                width="130px"
            >
            </el-table-column>
            <el-table-column
                label="備註"
                prop="memo"
                sortable = "custom"
            >
            </el-table-column>
                     <el-table-column
              fixed="right"
              label="操作"
              width="150"
              v-if="$store.state.auth.role === 'admin' | $store.state.auth.role === 'org-admin'">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="editDevice(scope.row.id)"
                  
                  size="mini">
                  編輯
                </el-button>
                <el-button
                  @click.native.prevent="deleteDevice(scope.row.id)"
                  type="danger"
                  size="mini">
                  刪除
                </el-button>
              </template>
          </el-table-column>
          </el-table>

    </CRow>
    <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </CRow>
    <el-dialog title="批次修改" :visible.sync="dialogBatchEditFormVisible" v-loading="loading" element-loading-text="作業中">
      <el-form :model="batchForm" ref="batchForm">
        <el-form-item label="群組動作" :label-width="formLabelWidth" prop="groupAction" >
          <el-radio-group v-model="batchForm.groupAction">
            <el-radio label="append">新增</el-radio>
            <el-radio label="remove">移除</el-radio>
            <el-radio label="replace">取代</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="群組" class="groups" :label-width="formLabelWidth" prop="groups">
        <div style="all:initial;">
              <el-transfer
                v-model="batchForm.groups"
                filterable
                :titles="['候選', '已加入']"
                :props="{
                  key: 'id',
                  label: 'name'
                }"
                :data="groups">
                <span slot-scope="{ option }"><el-tooltip :content="option.organization.name"><el-tag effect="dark" :type="option.type">{{ option.name }}</el-tag></el-tooltip></span>
              </el-transfer>
          </div>
        </el-form-item>
        <el-form-item label="生效日期" :label-width="formLabelWidth" prop="start_date">
          <el-date-picker type="date" value-format="timestamp" placeholder="選擇日期"  v-model="batchForm.start_date"></el-date-picker>
        </el-form-item>
        <el-form-item label="失效日期" :label-width="formLabelWidth" prop="end_date">
          <el-date-picker type="date" value-format="timestamp" placeholder="選擇日期"  v-model="batchForm.end_date"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBatchEditFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">確 定</el-button>
      </div>
     </el-dialog>

    <el-dialog title="新增人員" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="form" :rules="rules">
         <el-form-item label="名稱" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="人員編號" :label-width="formLabelWidth" prop="no">
          <el-input v-model="form.no" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="班級名稱" :label-width="formLabelWidth" prop="class_name">
          <el-input v-model="form.class_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所屬單位" :label-width="formLabelWidth" prop="organization">
          <el-select v-model="form.organization" filterable placeholder="請選擇" @change="onOrgChange">
            <el-option
              v-for="item in organizations"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生效日期" :label-width="formLabelWidth" prop="start_date">
          <el-date-picker type="date" value-format="timestamp" placeholder="選擇日期"  v-model="form.start_date"></el-date-picker>
        </el-form-item>
        <el-form-item label="失效日期" :label-width="formLabelWidth" prop="end_date">
          <el-date-picker type="date" value-format="timestamp" placeholder="選擇日期"  v-model="form.end_date"></el-date-picker>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="月光機序號" :label-width="formLabelWidth" prop="moonlight2_serial_number">
          <el-input v-model="form.moonlight2_serial_number" autocomplete="off"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="綁定澈見幸福App" :label-width="formLabelWidth" prop="is_link_luciditv_app"><el-switch
                  v-model="form.is_link_luciditv_app"
                  active-text="是"
                  inactive-text="否"></el-switch></el-form-item>
         <el-form-item label="註冊電話國碼" :label-width="formLabelWidth" prop="phone_area">
          <el-input v-model="form.phone_area" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="註冊電話號碼" :label-width="formLabelWidth" prop="phone_number">
          <el-input v-model="form.phone_number" autocomplete="off"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="群組" class="groups" :label-width="formLabelWidth" prop="groups">
          <div style="all:initial;">
              <el-transfer
                v-model="form.groups"
                filterable
                :titles="['候選', '已加入']"
                :props="{
                  key: 'id',
                  label: 'name'
                }"
                :data="groups">
                <span slot-scope="{ option }"><el-tag effect="dark" :type="option.type">{{ option.name }}</el-tag></span>
              </el-transfer>
          </div>
        </el-form-item>

          <el-form-item label="備註" :label-width="formLabelWidth" prop="memo">
            <el-input type="textarea" v-model="form.memo"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">確 定</el-button>
      </div>
  </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue'
import moment from "moment-timezone";
import API from '@/api/'
Vue.filter('converDate',function(value){
  if(value){
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return moment(value).tz(tz).format('YYYY-MM-DD');
  }else{
    return value;
  }

})
export default {
  name: 'AccountList',
  async created () {
          await this.$store.dispatch('organization/list', {max: 1000, offset: 0, isForSelect: true}, {
          root: true
      });
      await this.$store.dispatch('group/list', {max: 1000, offset: 0}, {
          root: true
      });
      await this.$store.dispatch('account/list', {sort: 'no', order: 'ascending', max: 50, offset: 0}, {
          root: true
      });
  },
  data() {
            var validateSerialNumber = (rule, value, callback) => {
            if (this.form.id) {
                 const data = this.getAccountById(this.form.id);
                 if ( data.moonlight2_serial_number === value) {
                   callback();
                   return;
                 }
            } 
            /*
            API.account.search({moonlight2_serial_number: value}).then(res =>{
              if (res.data.length == 0) {
                  callback();
              } else {
                callback(new Error('已存在'));
              } 
            })
            */
        };
        return {
          loading: false,
          multipleSelection: [],
          batchForm: {
            groupAction: '',
            groups: [],
            start_date: null,
            end_date: null
          },
          dialogBatchEditFormVisible: false,
          pageSize:50,
          currentPage:0,
          queryForm: {
            qstr: '',
            groups: [],
            organization: []
          },
          form: {
            id: null,
            moonlight2_serial_number:null,
            organization:null,
            name:'',
            groups:[],
            start_date:null,
            end_date:null,
            memo:'',
            no:'',
            class_name:'',
            phone_number: '',
            phone_area: '',
            is_link_luciditv_app: false
          },
          groups: [],
          dialogFormVisible: false,
          formLabelWidth: '125px',
          rules: {
            organization: [
              { required: true, message: '請選擇所屬單位', trigger: 'blur' },
            ],
            name: [
              { required: true, message: '請輸入名稱', trigger: 'blur' },
            ],
            start_date: [
              { required: true, message: '請輸生效日期', trigger: 'blur' },
            ],
          },
        }
  },
  methods:{
    onQueryOrganizationChange(val) {
      if (val) {
        this.$store.dispatch('group/list', {max: 1000, offset: 0, organization: val}, {
              root: true
          });
      } else {
        this.$store.dispatch('group/list', {max: 1000, offset: 0}, {
              root: true
          });
      }
    },
    tableCellClassName({row, column, rowIndex, columnIndex}) {
      const now = new Date().getTime();
      if(column.property === 'start_date'){
        if (row.start_date > now) {
          return 'warning-cell';
        } 
      }
      if(column.property === 'end_date'){
        if(row.end_date < now){
            return 'warning-cell';
        }
      }
      return '';
    },
    batchDelete() {
      this.$confirm('此操作將永久刪除該人員, 是否繼續?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('account/batchDelete', {accounts: this.multipleSelection.map(i=>i.id)} , {
            root: true
          }).then( res => {
            this.query(this.pageSize,this.offset, this.sort, this.order,this.queryParams)
            this.$message({
            type: 'success',
            message: '删除成功!'
          });
          })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    batchEdit() {
      this.$store.dispatch('group/list', {max: 1000, offset: 0}, {
          root: true
      }).then(()=>{
        this.groups = this.queryGroups;
      })
      if(this.$refs['batchForm']) {
        this.$refs['batchForm'].resetFields();
      }
      this.dialogBatchEditFormVisible = true;
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    submitBatch() {
      this.loading = true;
      this.$store.dispatch('account/batch', {accounts: this.multipleSelection.map(i=>i.id),...this.batchForm}, {
            root: true
        }).then(()=>{
          this.loading = false;
          this.dialogBatchEditFormVisible =false;
          this.query(this.pageSize,this.offset, this.sort, this.order ,this.queryParams)
        })
    },
    addDevice() {
      this.$store.dispatch('organization/list', {max: 1000, offset: 0, isForSelect: true }, {
          root: true
      });
      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
      }
      this.form.id = null;
      this.form.moonlight2_serial_number=null;
      this.form.organization='';
      this.form.name='';
      this.form.groups=[];
      this.form.start_date = moment().startOf('day').toDate().getTime();
      this.form.end_date=null;
      this.form.memo='';
      this.form.no='';
      this.form.class_name='';
      this.dialogFormVisible = true;
      this.groups=[];
      this.form.phone_number = '';
      this.form.phone_area = '';
      this.form.is_link_luciditv_app = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val,this.offset, this.sort, this.order, this.queryForm);
      },
      handleCurrentChange(val) {
        this.query(this.pageSize,this.pageSize*(val-1), this.sort, this.order, this.queryForm);

      },
    query(max,offset, sort, order, param = {}) {
      this.$store.dispatch('account/list', {max: max, offset: offset, sort: sort, order: order, ...param}, {
          root: true
      });
    },
    download(sort ,order, params = {}) {
      API.account.download({ sort, order, ...params}).then(res=>{
        const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));

        const link = document.createElement('a');

        link.href = downloadUrl;

        link.setAttribute('download', 'export.xlsx'); //any other extension

        document.body.appendChild(link);

        link.click();

        link.remove();

      })
    },
    indexFormatter(index){
     return `#${parseInt(this.offset)+ index + 1}`;

    },
    dateFormatter(row, column, cellValue){
      if(cellValue){
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return moment(parseInt(cellValue)).tz(tz).format('YYYY-MM-DD');
        //return moment(cellValue).format('YYYY-MM-DD');
      }else{
        return cellValue;
      }

    },
    dateFormatter2(row, column, cellValue){
      if(cellValue){
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return moment.tz(cellValue,tz).format('YYYY-MM-DD');
        //return moment(cellValue).format('YYYY-MM-DD');
      }else{
        return cellValue;
      }

    },
    onOrgChange(selectedValue) {
      this.$store.dispatch('organization/getWithGroups', selectedValue, {
          root: true
      }).then(res=>{
        this.groups = res.data.groups;
        this.form.groups = [];
      })
      
      
    },
    submit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
              if(this.form.id) {
                this.submitUpdate();
              } else {
                this.submitAdd();
              }
          } else {
            return false;
          }
        });
    },
    submitAdd() {
        this.$store.dispatch('account/add', this.form, {
          root: true
        }).then( res => {
        
        this.dialogFormVisible = false;
        this.form.id=null;
        if (this.$refs['form']) {
        this.$refs['form'].resetFields();
      }
        this.query(this.pageSize,this.offset, this.sort, this.order, this.queryForm)
      })
    },
    submitUpdate() {
      this.$store.dispatch('account/update', this.form , {
          root: true
      }).then( res => {
        this.dialogFormVisible = false;
        this.form.id=null;
        if (this.$refs['form']) {
        this.$refs['form'].resetFields();
      }
        this.query(this.pageSize,this.offset, this.sort, this.order, this.queryForm)
      })
    },
    editDevice(device_id) {
      const self = this;
      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
      }
      this.$store.dispatch('organization/list', {max: 1000, offset: 0, isForSelect: true} , {
          root: true
      }).then( res => {
        const data = this.getAccountById(device_id);
        if(data.organization) {
          self.$store.dispatch('organization/getWithGroups', data.organization.id, {
            root: true
          }).then(res2=>{
            self.groups = res2.data.groups;
            self.form.groups = [];
            self.form.organization = data.organization.id;
          self.form.moonlight2_serial_number = data.moonlight2_serial_number;
          
          self.form.id=data.id;
          self.form.name=data.name;
          self.form.memo=data.memo;
          self.form.no=data.no;
          self.form.class_name=data.class_name;
          self.form.phone_number = data.phone_number;
          self.form.phone_area =  data.phone_area;
          self.form.is_link_luciditv_app = data.is_link_luciditv_app;
          if(data.groups){
            self.form.groups=data.groups.map(tag=>tag.id);
          } else {
            self.form.groups = [];
          }
          self.form.start_date= data.start_date;
          self.form.end_date= data.end_date;
          self.dialogFormVisible = true;
          })
        } else {
          this.groups = [];
          this.form.organization = null;
        }
    
      })
       
    },
    deleteDevice(organization_id) {
      this.$confirm('此操作將永久刪除該人員, 是否繼續?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('account/remove', organization_id , {
            root: true
          }).then( res => {
            this.query(this.pageSize,this.offset, this.sort, this.order, this.queryForm)
            this.$message({
            type: 'success',
            message: '删除成功!'
          });
          })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });

    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit('account/SET_SORT','no',{root: true})
        this.$store.commit('account/SET_ORDER','ascending',{root: true})
      } else {
        this.$store.commit('account/SET_SORT',args.prop,{root: true})
        this.$store.commit('account/SET_ORDER',args.order,{root: true})
      }
      
      this.query(this.pageSize,this.offset,this.sort,this.order, this.queryForm)
    },
  },
  computed: {
      ...mapGetters({
          // 取得資料夾列表
          accounts: 'account/accounts',
          total:'account/total',
          max:'account/max',
          offset:'account/offset',
          organizations: 'organization/organizations',
          getOrganizationById: 'organization/getOrganizationById',
          getAccountById: 'account/getAccountById',
          sort: 'account/sort',
          order: 'account/order',
          queryGroups: 'group/groups',
      })
  },
}
</script>

<style scoped>
  .tag_group .el-tag+.el-tag {
    margin-left: 10px;
  }
  .el-transfer >>> .el-transfer__buttons {
    width: 100px;
  }
  .el-transfer >>> .el-transfer__buttons .el-button+.el-button {
    margin-left: 0px;
  }
  .el-table >>> .el-table__body td.warning-cell{
    color:#F56C6C;
  }
</style>
